import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import { useNavigate } from "react-router-dom";
import "./AlertModal.css";

export const AlertModal = (props) => {
  const {
    isShow,
    onClose,
    title,
    text,
    actionButtonTitle,
    actionUrl,
    message,
  } = props;

  const navigate = useNavigate();
  const [show, setShow] = useState(isShow);

  useEffect(() => {
    setShow(isShow);
  }, [isShow]);

  const handleClose = () => {
    onClose(false);
  };

  const handleAction = () => {
    if (actionUrl) navigate(actionUrl);
    onClose(false);
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Body>
        <div className="title fs-4">{title}</div>
        <div
          className="message text-center text-white fs-5 mt-3"
          dangerouslySetInnerHTML={{ __html: message }}
        />
        {text && (
          <div
            className="text text-center text-white fs-5 mt-1"
            dangerouslySetInnerHTML={{ __html: text }}
          />
        )}
        <div className="d-flex justify-content-center mt-4">
          {actionButtonTitle && (
            <Button
              variant=""
              className="mx-2 modal-secondary-btn"
              style={{ minWidth: 70, fontSize: 22 }}
              onClick={handleAction}
            >
              {actionButtonTitle}
            </Button>
          )}
          {actionButtonTitle !== "Close" && (
            <Button
              variant=""
              className="mx-2 text-white modal-primary-btn"
              style={{ minWidth: 70, fontSize: 20 }}
              onClick={handleClose}
            >
              Close
            </Button>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};
